const comments = [
  {
    name: '赛事观察员老张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20male%20portrait%20in%20a%20warm%20studio%20setting%2C%20friendly%20expression%2C%20clean%20background%2C%20soft%20lighting%2C%20business%20casual%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '作为每日大赛的老用户，经常遇到网址变更的问题。51每日大赛这个导航站真是太及时了，每次都能第一时间找到最新入口，再也不用到处搜索了！',
    time: '3天前',
  },
  {
    name: '追赛小能手阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20man%20portrait%20with%20a%20warm%20smile%2C%20casual%20style%2C%20clean%20soft%20background%2C%20natural%20lighting%2C%20friendly%20and%20approachable%20look&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '用了51每日大赛推荐的APP下载方式，安装非常顺利。以前找安装包总是担心中病毒，这个网站的入口都是验证过的，用起来放心多了。',
    time: '5天前',
  },
  {
    name: '赛事数据控小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20woman%20portrait%20with%20a%20confident%20smile%2C%20modern%20office%20background%2C%20soft%20natural%20lighting%2C%20warm%20tone%2C%20approachable%20professional%20look&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '网站的信息更新速度真的很快，昨天官方刚换网址，今天这里就同步了。而且备用入口也很有用，关键时刻能救急。收藏了！',
    time: '1周前',
  },
  {
    name: '新手上路小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20person%20portrait%2C%20warm%20genuine%20smile%2C%20casual%20everyday%20style%2C%20clean%20soft%20background%2C%20natural%20lighting%2C%20approachable%20and%20kind%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    text: '第一次用每日大赛，完全不知道从哪里开始。多亏了这个网站的「新手指南」和「注册教程」，一步步跟着操作很快就上手了，强烈推荐给新人！',
    time: '2周前',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            用户声音
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自每日大赛用户的真实反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/70 p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex gap-0.5 mt-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs text-accent-400"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}